<ui-card>
    <h2 *ngIf="showHeaderInCard" class="margin-bottom-4">{{ 'time-off-v3.createTimeOffType' | translate }}</h2>

    <div class="grid-row">
        <mat-form-field class="field">
            <mat-label>{{ 'time-off-v3.type-store-form.nameLabel' | appTranslate }}</mat-label>
            <input
                name="typeName"
                [placeholder]="'time-off-v3.type-store-form.namePlaceholder' | appTranslate"
                #typeName="ngModel"
                required
                [(ngModel)]="timeOffType.name"
                matInput
            />
            <mat-error *ngIf="typeName.invalid">{{ typeName.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="flex middle">
            <ui-info [text]="typesToolTips.typeName"></ui-info>
        </div>
    </div>

    <div class="grid-row">
        <mat-form-field class="field">
            <mat-label>{{ 'time-off-v3.type-store-form.colorLabel' | appTranslate }}</mat-label>
            <ui-color-picker
                placeholder="#000000"
                name="colorPicker"
                [(ngModel)]="timeOffType.color"
                required
                #colorPicker="ngModel"
            ></ui-color-picker>
            <mat-error *ngIf="colorPicker.invalid">{{ colorPicker.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="flex middle">
            <ui-info [text]="typesToolTips.color"></ui-info>
        </div>
    </div>

    <div class="grid-row">
        <mat-form-field class="field">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.type-store-form.iconLabel' | appTranslate }}</mat-label>
            <mat-select
                [placeholder]="'time-off-v3.type-store-form.iconPlaceholder' | appTranslate"
                name="iconSelector"
                [(ngModel)]="timeOffType.icon"
                #iconSelector="ngModel"
                required
            >
                <mat-select-trigger>
                    <mat-icon [svgIcon]="iconSelector.value"></mat-icon>&nbsp;{{
                        getIconLabel(iconSelector.value) | translate
                    }}
                </mat-select-trigger>
                <mat-option *ngFor="let timeOffIcon of timeOffIcons" [value]="timeOffIcon">
                    <mat-icon [svgIcon]="timeOffIcon"></mat-icon> {{ getIconLabel(timeOffIcon) | translate }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="iconSelector.invalid">{{ iconSelector.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="grid-row">
        <mat-form-field class="field">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.type-store-form.visibilityLabel' | appTranslate }}</mat-label>
            <mat-select
                name="visibility"
                [placeholder]="'time-off-v3.type-store-form.visibilityPlaceholder' | appTranslate"
                [(ngModel)]="timeOffType.isPublic"
                #visibility="ngModel"
                required
            >
                <mat-option [value]="true">{{
                    'time-off-v3.type-store-form.visibilityOptions.public' | appTranslate
                }}</mat-option>
                <mat-option [value]="false">{{
                    'time-off-v3.type-store-form.visibilityOptions.private' | appTranslate
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="visibility.invalid">{{ visibility.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="flex middle">
            <ui-info [text]="typesToolTips.visibility"></ui-info>
        </div>
    </div>

    <div class="grid-row">
        <mat-form-field class="field grow">
            <mat-label>{{ 'time-off-v3.type-store-form.descriptionLabel' | appTranslate }}</mat-label>
            <textarea
                name="description"
                [placeholder]="'time-off-v3.type-store-form.descriptionPlaceholder' | appTranslate"
                [(ngModel)]="timeOffType.description"
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
            ></textarea>
        </mat-form-field>
        <div class="flex middle">
            <ui-info [text]="typesToolTips.description"></ui-info>
        </div>
    </div>

    <div class="grid-row-three-items">
        <mat-form-field class="field first-item">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.type-store-form.trackTimeInLabel' | appTranslate }}</mat-label>
            <mat-select
                name="displayInHours"
                [placeholder]="'time-off-v3.type-store-form.trackTimeInPlaceholder' | appTranslate"
                [(ngModel)]="timeOffType.displayInHours"
                (ngModelChange)="onChange.emit()"
                required
                #displayHours="ngModel"
            >
                <mat-option [value]="true">{{
                    'time-off-v3.type-store-form.trackTimeInOptions.hours' | appTranslate
                }}</mat-option>
                <mat-option [value]="false">{{
                    'time-off-v3.type-store-form.trackTimeInOptions.days' | appTranslate
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="displayHours.invalid">{{ displayHours.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="field second-item">
            <mat-label
                >{{ 'time-off-v3.type-store-form.hoursPerDayLabel' | appTranslate
                }}<span class="hours-per-day-error margin-left-1" *ngIf="!isUpdate"
                    >({{ 'time-off-v3.type-store-form.hoursPerDayLabelExtra' | appTranslate }})</span
                >
            </mat-label>
            <input
                name="hoursPerDay"
                [placeholder]="'time-off-v3.type-store-form.hoursPerDayPlaceholder' | appTranslate"
                #hoursPerDay="ngModel"
                [textMask]="{ mask: numberMask }"
                [ngModel]="timeOffType.getLocalizedProperty('hoursPerDay')"
                (ngModelChange)="timeOffType.setLocalizedProperty('hoursPerDay', $event); onChange.emit()"
                [disabled]="isUpdate"
                required
                matInput
            />
            <mat-error *ngIf="hoursPerDay.invalid">{{ hoursPerDay.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="flex middle third-item">
            <ui-info [text]="typesToolTips.trackTime"></ui-info>
        </div>
    </div>

    <div class="grid-row">
        <mat-form-field class="field">
            <mat-label appRemoveAriaOwns>{{
                'time-off-v3.type-store-form.paidTimeSettingsLabelV2' | appTranslate
            }}</mat-label>
            <mat-select
                name="isPaid"
                [placeholder]="'time-off-v3.type-store-form.selectAnOption' | appTranslate"
                [(ngModel)]="timeOffType.isPaid"
                required
                #isPaid="ngModel"
            >
                <mat-option [value]="true">
                    {{ 'time-off-v3.type-store-form.paidTimeSettingsOptions.paidTime' | appTranslate }}
                </mat-option>
                <mat-option [value]="false">
                    {{ 'time-off-v3.type-store-form.paidTimeSettingsOptions.unpaidTime' | appTranslate }}
                </mat-option>
                <mat-option [value]="timeWorkedOption">
                    {{ 'time-off-v3.type-store-form.paidTimeSettingsOptions.timeWorked' | appTranslate }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="isPaid.invalid">{{ isPaid.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</ui-card>
